import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { NodesModel } from './models/nodes-model.interface';
import { NodesModelImpl } from './models/nodes-model';
import { NodesSummaryModel } from './models/nodes-summary-model.interface';
import { SelectedNodesModel } from './models/selected-nodes-model.interface';
import { TaggingSettingModel } from './models/tagging-setting-model.interface';
import { NodesSummaryModelImpl } from './models/nodes-summary-model';
import { SelectedNodesModelImpl } from './models/selected-nodes-model';
import { TaggingSettingModelImpl } from './models/tagging-setting-model';
import { AiTaggingRepository } from './repositories/ai-tagging-repository.interface';
import { AiTaggingRepositoryImpl } from './repositories/ai-tagging-repository';
import { AiTaggingApi } from './repositories/apis/ai-tagging-api.interface';
import { AiTaggingApiImpl } from './repositories/apis/ai-tagging-api';
import { FieldsService } from './services/fields-service.interface';
import { NodeParsingService } from './services/node-parsing-service.interface';
import { NodeParsingServiceImpl } from './services/node-parsing-service';
import { FieldsServiceImpl } from './services/fields-service';
import { NodeSummaryService } from './services/node-summary-service.interface';
import { NodesService } from './services/nodes-service.interface';
import { TaggingService } from './services/tagging-service.interface';
import { TaggingSettingService } from './services/tagging-setting-service.interface';
import { NodesServiceImpl } from './services/nodes-service';
import { TaggingServiceImpl } from './services/tagging-service';
import { TaggingSettingServiceImpl } from './services/tagging-setting-service';
import { AiTaggingCheckService } from './services/ai-tagging-check-service.interface';
import { AiTaggingCheckServiceImpl } from './services/ai-tagging-check-service';
import { SelectedNodesService } from './services/selected-nodes-service.interface';
import { SelectedNodesServiceImpl } from './services/selected-nodes-service';
import { NodeListRepositoryImpl } from './repositories/node-list-repository';
import { NodeListRepository } from './repositories/node-list-repository.interface';
import { NodeSummaryServiceImpl } from './services/node-summary-service';
export const aiTagging = new ContainerModule(bind => {
    bind(NodesModel).to(NodesModelImpl);
    bind(NodesSummaryModel).to(NodesSummaryModelImpl);
    bind(SelectedNodesModel).to(SelectedNodesModelImpl);
    bind(TaggingSettingModel).to(TaggingSettingModelImpl);
    bind(AiTaggingApi).to(AiTaggingApiImpl);
    bind(AiTaggingRepository).to(AiTaggingRepositoryImpl);
    bind(NodeListRepository).to(NodeListRepositoryImpl);
    bind(FieldsService).to(FieldsServiceImpl);
    bind(NodeParsingService).to(NodeParsingServiceImpl);
    bind(NodeSummaryService).to(NodeSummaryServiceImpl);
    bind(NodesService).to(NodesServiceImpl);
    bind(SelectedNodesService).to(SelectedNodesServiceImpl);
    bind(TaggingService).to(TaggingServiceImpl);
    bind(TaggingSettingService).to(TaggingSettingServiceImpl);
    bind(AiTaggingCheckService).to(AiTaggingCheckServiceImpl);
});
